import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from 'react-datepicker'
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
import 'react-datepicker/dist/react-datepicker.css'
import es from "date-fns/locale/es";
registerLocale('es', es);

const totalSectionStyle = {
    background: '#033c73',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
};

// Función auxiliar para formatear números de forma segura
const safeNumberFormat = (value) => {
  if (value === null || value === undefined) return '0.00';
  const numericValue = parseFloat(value || '0');
  if (isNaN(numericValue)) return '0.00';
  return numericValue.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const CashCut = () => {
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [dataTicket, setDataTicket] = useState([]);
    const [dataPackage, setDataPackage] = useState([]);
    const [packagesToCollect, setPackagesToCollect] = useState([]);
    const [packagesAdvances, setPackagesAdvances] = useState([]);
    const [extraLuggage, setExtraLuggage] = useState([]);
    const [dataBills, setDataBills] = useState([]);
    const [schedules, setSchedules] = useState([]);
    const [dataBillsWay, setDataBillsWay] = useState ([]);
    const [totalSales, setTotalSales] = useState(0);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        setTimeout(() => {
            // Initialize tooltips
            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new Tooltip(tooltipTriggerEl);
            });
        }, 100);
    }, []);

    useEffect(() => {
    axios.get(ENDPOINT + "get-all-schedules/2")
        .then(res => setSchedules(res.data.data || []));
    }, []);



    const handleSearch = async () => {
        const form = new FormData();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const dateFormat = year + '-' + month + '-' + day;
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        form.append('date', dateFormat);
        form.append('user_id', user_id);
        setLoading(true);
        await axios.post(ENDPOINT + 'cash-cut', form).then(response => {
            setLoading(false);
            setDataTicket(response.data.data.tickets);
            setDataPackage(response.data.data.packages);
            setPackagesToCollect(response.data.data.packagesToCollect);
            setPackagesAdvances(response.data.data.packagesAdvances);
            setExtraLuggage(response.data.data.extraLuggage);
            setDataBills(response.data.data.bills);
            setDataBillsWay(response?.data?.data?.BillsWay || []); 
            const totalTickets = response.data.data.tickets.reduce((a, b) => a + parseFloat(b.price_ticket), 0);
            const totalPackages = response.data.data.packages.reduce((a, b) => a + parseFloat(b.price), 0);
            const totalPackagesToCollect = response.data.data.packagesToCollect.reduce((a, b) => a + parseFloat(b.price - b.advance), 0);
            const totalPackagesAdvances = response.data.data.packagesAdvances.reduce((a, b) => a + parseFloat(b.advance), 0);
            const totalExtraLuggage = response.data.data.extraLuggage.reduce((a, b) => a + parseFloat(b.price), 0);
            const totalBillsWay = response.data.data.BillsWay.reduce((a, b) => a + parseFloat(b.ingreso), 0); 
            setTotalSales(totalTickets + totalPackages + totalPackagesToCollect + totalPackagesAdvances + totalExtraLuggage);
        }).catch(function (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        setLoading(true);
        const form = new FormData();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const date_send = year + '-' + month + '-' + day;
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        form.append('date', date_send);
        form.append('user_id', user_id); 
        await axios.post(ENDPOINT + 'export-cash-cut', form, { responseType: 'blob' }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'corte-de-caja-' + date_send + '.xlsx');
            document.body.appendChild(link);
            link.click();
        }).catch(function (error) {
            console.log(error);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Error! No hay datos para descargar </div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
        setLoading(false);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatTime = (timeString) => {
        if (!timeString) return "";
        const [hours, minutes] = timeString.split(':');
        const date = new Date();
        date.setHours(hours);
        date.setMinutes(minutes);
        const formattedMinutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        const hours12 = (date.getHours() % 12) || 12;
        const formattedHours12 = hours12.toString().padStart(2, '0');
        return `${formattedHours12}:${formattedMinutes} ${ampm}`;
    };

    // Filtrar boletos con pago con tarjeta o transferencia
    const filteredTickets = dataTicket
      ? dataTicket.filter((item) => item.card_payment == 1 || item.card_payment_transfer == 1)
      : [];

      // Filtrar paquetes con pago con tarjeta o transferencia
    const filteredPackages = dataPackage
    ? dataPackage.filter((item) => item.card_payment == 1 || item.cardPaymentTransfer == 1)
    : [];
    
    // Filtrar gastos con pago con tarjeta o transferencia
    const filteredBills = dataBills
      ? dataBills.filter((item) => item.card_payment == 1 || item.card_payment_transfer == 1)
      : [];

      const filteredPackagesToCollect = packagesToCollect
  ? packagesToCollect.filter((item) => 
      item.metod_payment_receive == 1 || 
      item.metod_payment_receive == 2
    )
  : [];
    
    // Combinar ambos arrays para la sección de pagos con tarjeta y transferencia
    const allCardPayments = [
      ...filteredTickets.map(ticket => ({
        date: ticket.date_sale,
        concept: ticket.invoice,
        passenger_name: ticket.name + " " + (ticket.last_name || ""),
        price: ticket.price_ticket,
        card_payment: ticket.card_payment,
        card_payment_transfer: ticket.card_payment_transfer,
        card_payment_transfer_reference: ticket.transfernumber
      })),

      ...filteredPackages.map(pkg => ({
        type: 'package',
        date: pkg.date_sale || pkg.date_created,
        concept: pkg.invoice_number,
        passenger_name: pkg.description_package,
        price: pkg.price,
        card_payment: pkg.card_payment,
        cardPaymentTransfer: pkg.cardPaymentTransfer
      })),
     ...filteredPackagesToCollect.map(pkg => ({
    type: 'package_to_collect',
    date: pkg.date_send || pkg.date_created,
    concept: pkg.invoice_number,
    passenger_name: pkg.description_package || pkg.addressee,
    price: (pkg.price || 0) - (pkg.advance || 0), // Usar el monto por cobrar
    metod_payment_receive: pkg.metod_payment_receive,
    card_payment: pkg.card_payment,
    cardPaymentTransfer: pkg.cardPaymentTransfer,
    is_package_to_collect: true // Bandera para identificar que es paquete por cobrar
  })),
  ...filteredBills
];
   

    
  
    // Calcular el total de los pagos filtrados
    const totalFilteredPayments = allCardPayments.reduce((a, b) => a + parseFloat(b.price || 0), 0);

  
    // Determinar el tipo de pago
    const getPaymentType = (item) => {
      if (item.card_payment == 1) return "Tarjeta";
      if (item.card_payment_transfer == 1) return "Transferencia";
      if (item.cardPaymentTransfer == 1) return "Transferencia";
      if (item.metod_payment_receive == 1) return "Tarjeta";
  if (item.metod_payment_receive == 2) return "Transferencia";
      return "Otro";
    };

    

    const renderScheduleTime = (item) => {
    if (item.time) return formatTime(item.time);
    
    if (item.schedule_id) {
        const schedule = schedules.find(s => s.schedule_id == item.schedule_id);
        if (schedule) return formatTime(schedule.time);
    }
    
    return '--:--';
    };

    return (
        <div>
            {loading && <Loader />}
            <div className="container-fluid">
                <ContentHeader title="Módulo de Reportes" />
            </div>

            <div className="container-fluid">
                <div className="card shadow-sm">
                    <div className="card-header py-3">
                        <div className="row align-items-center">
                            <div className="col-md-8">
                                <h4 className="card-title m-0 page-title d-flex align-items-center">
                                    <i className="bi bi-cash me-2"></i> Corte de Caja
                                </h4>
                            </div>
                            <div className="col-md-4 text-md-end">
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row g-4 mb-4">
                            <div className="col-lg-7">
                                <div className="search-controls bg-light p-4 rounded-3 shadow-sm h-100">
                                    <div className="add-trips-card-body">
                                        <div className="mb-4">
                                            <h6 className="text-muted mb-3">
                                                <i className="fas fa-info-circle me-2"></i>
                                                Seleccione una fecha para visualizar el corte de caja
                                            </h6>
                                        </div>
                                        <div className="row align-items-end">
                                            <div className="col-md-7 mb-3 mb-md-0">
                                                <label htmlFor="date" className="form-label fw-bold mb-2">
                                                    <i className="far fa-calendar-alt me-2"></i>
                                                    Fecha del Corte
                                                </label>
                                                <div className="input-group">
                                                    <DatePicker
                                                        showIcon
                                                        locale="es"
                                                        selected={date}
                                                        onChange={(date) => setDate(date)}
                                                        className="form-control form-control-sm"
                                                        dateFormat="dd, MMMM, yyyy"
                                                        placeholderText="Seleccionar fecha..."
                                                    />
                                                </div>
                                                <small className="text-muted mt-1 d-block">
                                                    La información corresponderá a la fecha seleccionada
                                                </small>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="d-grid gap-2">
                                                    <button
                                                        onClick={() => handleSearch()}
                                                        className="btn btn-primary btn-sm d-flex align-items-center justify-content-center py-2">
                                                        <i className="fa fa-search me-2"></i> Buscar
                                                    </button>
                                                    <button
                                                        onClick={() => handlePrint()}
                                                        className="btn btn-success btn-sm d-flex align-items-center justify-content-center py-2">
                                                        <i className="fa-solid fa-file-excel me-2"></i> Exportar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="cash-cut-summary h-100 text-white p-4 rounded-3 shadow position-relative overflow-hidden">
                                    <div className="position-relative z-1">
                                        <h6 className="text-white-50 mb-3">Total de ventas del día</h6>
                                        <h2 className="display-4 fw-bold mb-0">
                                            ${safeNumberFormat(totalSales)}
                                        </h2>
                                        <p className="mb-0 mt-2 text-white-50">
                                            <i className="fas fa-calendar-day me-1"></i> 
                                            {date.toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
                                        </p>
                                    </div>
                                    <div className="position-absolute bottom-0 end-0 p-4 opacity-25">
                                        <i className="fas fa-chart-line" style={{ fontSize: '5rem' }}></i>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h2 className="earnings-report-title h5 mb-1">
                                    <i className="fas fa-ticket-alt me-2"></i>
                                    Boletos del Día
                                </h2>
                                <p className="earnings-report-description small text-muted mb-2">
                                    Registro detallado de todos los boletos vendidos durante el día seleccionado.
                                </p>
                            </div>
                            <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                                <small className="d-block mb-1 text-white-50">Total Boletos</small>
                                <h4 className="m-0">${safeNumberFormat(dataTicket.reduce((a, b) => a + parseFloat(b.price_ticket || 0), 0))}</h4>
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-header">
                                <h4 className="card-title m-0 page-sub-title">
                                    <i className="fas fa-ticket-alt me-2"></i> Boletos
                                </h4>
                            </div>
                            <div className="card-body">
                                <table className="table table-hover table-striped table-responsive">
                                    <thead>
                                        <tr>
                                            <th width="25%" className="text-center">Folio</th>
                                            <th width="25%" className="text-center">Fecha de Viaje</th>
                                            <th width="25%" className="text-center">Horario</th>
                                            <th width="25%" className="text-center">Precio</th>
                                        </tr>
                                    </thead>
                                    {dataTicket ? (
                                        <tbody>
                                            {dataTicket.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {item.invoice}
                                                    </td>
                                                    <td className="text-center">
                                                        {formatDate(item.date_ticket)}
                                                    </td>
                                                    <td className="text-center">
                                                        {formatTime(item.time_ticket)}
                                                    </td>
                                                    <td className="text-center">
                                                        ${safeNumberFormat(item.price_ticket)}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan="3" className="text-end"><strong>Total</strong></td>
                                                <td className="text-center"><strong>${safeNumberFormat(dataTicket.reduce((a, b) => a + parseFloat(b.price_ticket || 0), 0))}</strong></td>
                                            </tr>
                                        </tbody>
                                    ) : 'No hay datos para mostrar'}
                                </table>
                            </div>
                        </div>

                        <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h2 className="earnings-report-title h5 mb-1">
                                    <i className="fas fa-box me-2"></i>
                                    Paquetería
                                </h2>
                                <p className="earnings-report-description small text-muted mb-2">
                                    Resumen de envíos y paquetes procesados en la fecha seleccionada.
                                </p>
                            </div>
                            <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                                <small className="d-block mb-1 text-white-50">Total Paquetería</small>
                                <h4 className="m-0">${safeNumberFormat(dataPackage.reduce((a, b) => a + parseFloat(b.price || 0), 0))}</h4>
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-header">
                                <h4 className="card-title m-0 page-sub-title">
                                    <i className="fas fa-box me-2"></i> Paqueteria
                                </h4>
                            </div>
                            <div className="card-body">
                                <table className="table table-hover main table-striped table-responsive">
                                    <thead>
                                        <tr>
                                            <th width="25%" className="text-center">Folio</th>
                                            <th width="25%" className="text-center">Fecha de Envio</th>
                                            <th width="25%" className="text-center">Horario</th>
                                            <th width="25%" className="text-center">Precio</th>
                                        </tr>
                                    </thead>
                                    {dataPackage ? (
                                        <tbody>
                                            {dataPackage.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {item.invoice_number}
                                                    </td>
                                                    <td className="text-center">
                                                        {formatDate(item.date_send)}
                                                    </td>
                                                    <td className="text-center">
                                                        {formatTime(item.time_send)}
                                                    </td>
                                                    <td className="text-center">
                                                        ${safeNumberFormat(item.price)}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan="3" className="text-end"><strong>Total</strong></td>
                                                <td className="text-center"><strong>${safeNumberFormat(dataPackage.reduce((a, b) => a + parseFloat(b.price || 0), 0))}</strong></td>
                                            </tr>
                                        </tbody>
                                    ) : 'No hay datos para mostrar'}
                                </table>
                            </div>
                        </div>

                        <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h2 className="earnings-report-title h5 mb-1">
                                    <i className="fas fa-list me-2"></i>
                                    Paquetería por Cobrar
                                </h2>
                                <p className="earnings-report-description small text-muted mb-2">
                                    Detalle de paquetes pendientes de cobro al destinatario.
                                </p>
                            </div>
                            <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                                <small className="d-block mb-1 text-white-50">Total por Cobrar</small>
                                <h4 className="m-0">${safeNumberFormat(packagesToCollect.reduce((a, b) => a + parseFloat((b.price || 0) - (b.advance || 0)), 0))}</h4>
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-header">
                                <h4 className="card-title m-0 page-sub-title">
                                    <i className="fas fa-money-bill me-2"></i> Paqueteria Por Cobrar
                                </h4>
                            </div>
                            <div className="card-body">
                                <table className="table table-hover main table-striped table-responsive">
                                    <thead>
                                        <tr>
                                            <th width="25%" className="text-center">Folio</th>
                                            <th width="25%" className="text-center">Fecha de Envio</th>
                                            <th width="25%" className="text-center">Horario</th>
                                            <th width="25%" className="text-center">Precio</th>
                                        </tr>
                                    </thead>
                                    {packagesToCollect ? (
                                        <tbody>
                                            {packagesToCollect.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {item.invoice_number}
                                                    </td>
                                                    <td className="text-center">
                                                        {formatDate(item.date_send)}
                                                    </td>
                                                    <td className="text-center">
                                                        {formatTime(item.time_send)}
                                                    </td>
                                                    <td className="text-center">
                                                        ${safeNumberFormat((item.price || 0) - (item.advance || 0))}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan="3" className="text-end"><strong>Total</strong></td>
                                                <td className="text-center"><strong>${safeNumberFormat(packagesToCollect.reduce((a, b) => a + parseFloat((b.price || 0) - (b.advance || 0)), 0))}</strong></td>
                                            </tr>
                                        </tbody>) : 'No hay datos para mostrar'}
                                </table>
                            </div>
                        </div>

                        <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h2 className="earnings-report-title h5 mb-1">
                                    <i className="fas fa-money-bill-wave me-2"></i>
                                    Anticipos de Paquetería
                                </h2>
                                <p className="earnings-report-description small text-muted mb-2">
                                    Lista de pagos anticipados recibidos por servicios de paquetería.
                                </p>
                            </div>
                            <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                                <small className="d-block mb-1 text-white-50">Total Anticipos</small>
                                <h4 className="m-0">${safeNumberFormat(packagesAdvances.reduce((a, b) => a + parseFloat(b.advance || 0), 0))}</h4>
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-header">
                                <h4 className="card-title m-0 page-sub-title">
                                    <i className="fas fa-hand-holding-usd me-2"></i> Anticipos Paqueterias
                                </h4>
                            </div>
                            <div className="card-body">
                                <table className="table table-hover main table-striped table-responsive">
                                    <thead>
                                        <tr>
                                            <th width="20%" className="text-center">Horario</th>
                                            <th width="20%" className="text-center">Destinatario</th>
                                            <th width="20%" className="text-center">Destino</th>
                                            <th width="20%" className="text-center">Monto</th>
                                            <th width="20%" className="text-center">Folio</th>
                                        </tr>
                                    </thead>
                                    {packagesAdvances ? (
                                        <tbody>
                                            {packagesAdvances.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {formatTime(item.time_send)}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.addressee}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.destination.name}
                                                    </td>
                                                    <td className="text-center">
                                                        ${safeNumberFormat(item.advance)}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.invoice_number}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan="4" className="text-end"><strong>Total</strong></td>
                                                <td className="text-center"><strong>${safeNumberFormat(packagesAdvances.reduce((a, b) => a + parseFloat(b.advance || 0), 0))}</strong></td>
                                            </tr>
                                        </tbody>) : 'No hay datos para mostrar'}
                                </table>
                            </div>
                        </div>

                        <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h2 className="earnings-report-title h5 mb-1">
                                    <i className="fas fa-suitcase me-2"></i>
                                    Equipaje Extra
                                </h2>
                                <p className="earnings-report-description small text-muted mb-2">
                                    Registro de cargos adicionales por equipaje extra de pasajeros.
                                </p>
                            </div>
                            <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                                <small className="d-block mb-1 text-white-50">Total Equipaje Extra</small>
                                <h4 className="m-0">${safeNumberFormat(extraLuggage.reduce((a, b) => a + parseFloat(b.price || 0), 0))}</h4>
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-header">
                                <h4 className="card-title m-0 page-sub-title">
                                    <i className="fas fa-suitcase me-2"></i> Equipaje extra
                                </h4>
                            </div>
                            <div className="card-body">
                                <table className="table table-hover main table-striped table-responsive">
                                    <thead>
                                        <tr>
                                            <th width="20%" className="text-center">Folio</th>
                                            <th width="20%" className="text-center">Fecha</th>
                                            <th width="20%" className="text-center">Horario</th>
                                            <th width="20%" className="text-center">Concepto</th>
                                            <th width="20%" className="text-center">Precio</th>
                                        </tr>
                                    </thead>
                                    {extraLuggage ? (
                                        <tbody>
                                            {extraLuggage.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {item.invoice}
                                                    </td>
                                                    <td className="text-center">
                                                        {formatDate(item.date)}
                                                    </td>
                                                    <td className="text-center">
                                                        {formatTime(item.time)}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.concept}
                                                    </td>
                                                    <td className="text-center">
                                                        ${safeNumberFormat(item.price)}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan="4" className="text-end"><strong>Total</strong></td>
                                                <td className="text-center"><strong>${safeNumberFormat(extraLuggage.reduce((a, b) => a + parseFloat(b.price || 0), 0))}</strong></td>
                                            </tr>
                                        </tbody>) : 'No hay datos para mostrar'}
                                </table>
                            </div>
                        </div>

                        <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h2 className="earnings-report-title h5 mb-1">
                                    <i class="fas fa-bus me-2"></i>
                                    Ingresos de camino
                                </h2>
                                <p className="earnings-report-description small text-muted mb-2">
                                    Registro de cargos adicionales por ingresos de camino de pasajeros.
                                </p>
                            </div>
                            <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                                <small className="d-block mb-1 text-white-50">Total Ingresos de camino</small>
                                <h4 className="m-0">${safeNumberFormat(dataBillsWay.reduce((a, b) => a + parseFloat(b.ingreso || 0), 0))}</h4>
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-header">
                                <h4 className="card-title m-0 page-sub-title">
                                    <i class="fas fa-bus me-2"></i> Ingresos de camino
                                </h4>
                            </div>
                            <div className="card-body">
                                <table className="table table-hover main table-striped table-responsive">
                                    <thead>
                                        <tr>
                                            <th width="20%" className="text-center">Fecha</th>
                                            <th width="20%" className="text-center">Sucursal</th>
                                            <th width="20%" className="text-center">Horario</th>
                                            <th width="20%" className="text-center">Concepto</th>
                                            <th width="20%" className="text-center">Monto</th>
                                        </tr>
                                    </thead>
                                    {(dataBillsWay || []).length > 0 ? (
                                        <tbody>
                                            {dataBillsWay.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        {formatDate(item.fecha_viaje, "date_ticket")}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.branch.name || 'N/A'}
                                                    </td>
                                                    <td className="text-center">
                                                        {renderScheduleTime(item)}
                                                    </td>
                                                    <td className="text-center">
                                                        {item.notes || 'Sin notas'}
                                                    </td>
                                                    <td className="text-center">
                                                        ${safeNumberFormat(item.ingreso)}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td colSpan="4" className="text-end"><strong>Total</strong></td>
                                                <td className="text-center"><strong>${safeNumberFormat(dataBillsWay.reduce((a, b) => a + parseFloat(b.ingreso || 0), 0))}</strong></td>
                                            </tr>
                                        </tbody>
                                    ) : (
                                        <tbody>
                                            <tr>
                                                <td colSpan="5" className="text-center">No hay datos para mostrar</td>
                                            </tr>
                                        </tbody>
                                    )}
                                </table>
                            </div>
                        </div>

                        {/* Sección de pagos con tarjeta y transferencia - ACTUALIZADA */}
<div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
    <div>
        <h2 className="earnings-report-title h5 mb-1">
            <i className="fas fa-file-invoice-dollar me-2"></i>
            Pagos con Tarjeta y Transferencia
        </h2>
        <p className="earnings-report-description small text-muted mb-2">
            Pagos hechos con tarjeta o transferencia (Boletos, Paquetes y Paquetes por Cobrar).
        </p>
    </div>
    <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
        <small className="d-block mb-1 text-white-50">Total pagos</small>
        <h4 className="m-0">-${safeNumberFormat(totalFilteredPayments)}</h4>
    </div>
</div>

<div className="card mt-2">
    <div className="card-header">
        <h4 className="card-title m-0 page-sub-title">
            <i className="fas fa-file-invoice-dollar me-2"></i> Desglose de Pagos con Tarjeta y Transferencia
        </h4>
    </div>
    <div className="card-body">
        <table className="table table-hover main table-striped table-responsive">
            <thead>
                <tr>
                    <th width="12%" className="text-center">Fecha</th>
                    <th width="13%" className="text-left">Folio</th>
                    <th width="20%" className="text-center">Concepto/Pasajero</th>
                    <th width="15%" className="text-center">Tipo</th>
                    <th width="10%" className="text-center">Tipo Pago</th>
                    <th width="15%" className="text-center">Anotaciones</th>
                    <th width="15%" className="text-center">Cantidad</th>
                </tr>
            </thead>
            {allCardPayments.length > 0 ? (
                <tbody>
                    {allCardPayments.map((item, index) => (
                        <tr key={index}>
                            <td className="text-center">
                                {formatDate(item.date)}
                            </td>
                            <td className="text-left">
                                {item.concept}
                            </td>
                            <td className="text-center">
                                {item.passenger_name || '-'}
                                {item.is_package_to_collect && (
                                    <span className="badge bg-warning ms-1">Por Cobrar</span>
                                )}
                            </td>
                            <td className="text-center">
                                {item.type === 'ticket' ? 'Boleto' : 
                                 item.type === 'package' ? 'Paquete' :
                                 item.type === 'package_to_collect' ? 'Paquete por Cobrar' : 'Descuento'}
                            </td>
                            <td className="text-center">
                                {getPaymentType(item)}
                            </td>
                            <td className="text-left">
                                {item.card_payment_transfer_reference || '-'}
                            </td>
                            <td className="text-center">
                                -${safeNumberFormat(item.price)}
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td colSpan="6" className="text-end"><strong>Total Pagos</strong></td>
                        <td className="text-center"><strong>-${safeNumberFormat(totalFilteredPayments)}</strong></td>
                    </tr>
                </tbody>
            ) : (
                <tbody>
                    <tr>
                        <td colSpan="7" className="text-center">No hay datos para mostrar</td>
                    </tr>
                </tbody>
            )}
        </table>
    </div>
</div>

                        <div className="earnings-report-separator mb-3 d-flex justify-content-between align-items-center">
                            <div>
                                <h2 className="earnings-report-title h5 mb-1">
                                    <i className="fas fa-file-invoice-dollar me-2"></i>
                                    Gastos por Unidad
                                </h2>
                                <p className="earnings-report-description small text-muted mb-2">
                                    Registro de gastos operativos asociados a cada unidad de transporte.
                                </p>
                            </div>
                            <div className="total-section text-white rounded-3 p-3 shadow-sm" style={totalSectionStyle}>
                                <small className="d-block mb-1 text-white-50">Total Gastos</small>
                                <h4 className="m-0">-${safeNumberFormat(dataBills.reduce((a, b) => a + parseFloat(b.price || 0), 0))}</h4>
                            </div>
                        </div>

                        <div className="card mt-2">
                            <div className="card-header">
                                <h4 className="card-title m-0 page-sub-title">
                                    <i className="fas fa-file-invoice-dollar me-2"></i> Gastos por unidad
                                </h4>
                            </div>
                            <table className="table table-hover main table-striped table-responsive">
                                <thead>
                                    <tr>
                                        <th width="15%" className="text-center">Fecha</th>
                                        <th width="20%" className="text-left">Concepto</th>
                                        <th width="25%" className="text-left">Unidad</th>
                                        <th width="25%" className="text-left">Condcutor</th>
                                        <th width="15%" className="text-center">Monto</th>
                                    </tr>
                                </thead>
                                {dataBills ? (
                                    <tbody>
                                        {dataBills.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    {formatDate(item.date)}
                                                </td>
                                                <td className="text-left">
                                                    {item.concept}
                                                </td>
                                                <td className="text-left">
                                                    {item.unit.name}
                                                </td>
                                                <td className="text-left">
                                                    {item.driver.name}
                                                </td>
                                                <td className="text-center">
                                                    -${safeNumberFormat(item.price)}
                                                </td>
                                            </tr>
                                        ))}
                                         <tr>
                                            <td colSpan="4" className="text-end"><strong>Total Gastos</strong></td>
                                            <td className="text-center"><strong>-${safeNumberFormat(dataBills.reduce((a, b) => a + parseFloat(b.price || 0), 0))}</strong></td>
                                        </tr>
                                        <tr>
                                            <td colSpan="4" className="text-end"><strong>Total (Ventas + Ingresos Camino - Gastos - Pagos)</strong></td>
                                            <td className="text-center"><strong>${safeNumberFormat((totalSales + 
                                                ((dataBillsWay || []).reduce((a, b) => a + parseFloat(b.ingreso || 0), 0)) -
                                                totalFilteredPayments -
                                                (dataBills?.reduce((a, b) => a + parseFloat(b.price || 0), 0) || 0)
                                            ))}</strong></td>
                                        </tr>
                                    </tbody>
                                ) : 'No hay datos para mostrar'}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CashCut;